// extracted by mini-css-extract-plugin
export var input = "styles-module--input--Cfzo2";